

var screenWidth = window.screen.width;
var slides = screenWidth <= 490 ? 1 : 4;
const element = document.querySelector(".collectionn-slider"); 
        $('.collectionn-slider').slick({
    infinite: true,
    slidesToShow: slides,
    slidesToScroll: 1,
          arrows:true,
          responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
  });